// extracted by mini-css-extract-plugin
export default {"list":"RecommendedItemsModalList_list__j9S6R"};